export const messages = {
  loadMessage: 'Идет загрузка...',
  errorMessage: 'Что-то пошло не так, попробуйте еще раз.',
  searchMessage: 'По вашему запросу ничего не найдено.',
};
